This program has been developed by students from the bachelor Computer Science
at Utrecht University within the Software Project course. Copyright (c) Utrecht
University (Department of Information and Computing Sciences)

<template>
  <p class="copyright">&copy; Utrecht University (ICS)</p>
  <div class="questionButton" @click="toggleQuestionButton">
    <img src="@/assets/images/Wikiquestion.svg" alt="Wiki question cloud" />
    <div class="questionMark">?</div>

    <div class="questionPopUp basicBlock" :class="questionButton">
      <div class="subheader top">Help</div>

      <template
        v-for="option in this.wikiSubjects"
        :key="$t(option.wikiButton.name)"
      >
        <div class="blockEntry">
          <p @click="setWikiBookmark(option.wikiButton.item)">
            {{ option.wikiButton.name }}
          </p>
        </div>
      </template>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  data() {
    return {
      questionButton: "",
    };
  },
  props: {
    wikiSubjects: Array,
  },

  methods: {
    //Toggle question button on and off
    toggleQuestionButton() {
      if (this.questionButton == "openQuestion") {
        this.questionButton = "";
      } else {
        this.questionButton = "openQuestion";
      }
    },

    setWikiBookmark(item: string) {
      let routeData = this.$router.resolve({
        path: "/wiki",
        query: { item: item },
      });
      window.open(routeData.href, "_blank");
    },
  },
})
export default class QuestionButton extends Vue {}
</script>
